import { STRAIN_ORDER } from '@/constants';

const ORDER_INDEX = new Map(
  STRAIN_ORDER.map((label, index) => [label.toLowerCase(), index]),
);

export const sortByClassificationFilter = (values: string[]) =>
  [...values].sort((valueA, valueB) => {
    const positionA = ORDER_INDEX.get(valueA.toLowerCase());
    const positionB = ORDER_INDEX.get(valueB.toLowerCase());

    const isAKnown = positionA !== undefined;
    const isBKnown = positionB !== undefined;

    if (isAKnown && isBKnown)
      return (positionA as number) - (positionB as number); // both known → fixed order
    if (isAKnown && !isBKnown) return -1; // first known
    if (!isAKnown && isBKnown) return 1; // b known first
    return 0; // both unknown → do not touch
  });
